module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/lookup-management/lookup-management.component.css
// module id = ./src/app/admin/lookup-management/lookup-management.component.css
// module chunks = main